import React, { useState } from 'react';
import { Button } from '@components/ui/button';

const PREVIEW_LENGTH = 20;

export const PushTokenValue = ({ token }: { token: string }) => {
    const [revealed, setRevealed] = useState(false);
    const isShortened = token.length > PREVIEW_LENGTH;

    return (
        <div className="flex items-start gap-2">
            <span className="font-mono text-[0.85rem] break-all">
                {revealed || !isShortened
                    ? token
                    : `${token.slice(0, PREVIEW_LENGTH)}…`}
            </span>
            {isShortened && (
                <Button
                    variant="ghost"
                    size="sm"
                    className="h-6 px-2"
                    onClick={() => setRevealed(!revealed)}
                >
                    {revealed ? 'Hide' : 'Show'}
                </Button>
            )}
        </div>
    );
};
